import { createFormHook, createFormHookContexts } from '@tanstack/react-form'

import AIChatLauncherPositionSelectField from 'src/components/form/tanstack/AIChatLauncherPositionSelectField'
import CompanySearchField from 'src/components/form/tanstack/CompanySearchField'
import CompanySelectField from 'src/components/form/tanstack/CompanySelectField'
import CreatableStringSelectField from 'src/components/form/tanstack/CreatableStringSelectField'
import DateField from 'src/components/form/tanstack/DateField'
import DateTemplateInputField from 'src/components/form/tanstack/DateTemplateInputField'
import DistanceUnitSelectField from 'src/components/form/tanstack/DistanceUnitSelectField'
import EntityLayerSelectField from 'src/components/form/tanstack/EntityLayerSelectField'
import EntityVersionSearchField from 'src/components/form/tanstack/EntityVersionSearchField'
import FeeScheduleSelectField from 'src/components/form/tanstack/FeeScheduleSelectField'
import FeeTemplateSelectField from 'src/components/form/tanstack/FeeTemplateSelectField'
import FileUploadField from 'src/components/form/tanstack/FileUploadField'
import IconSelectField from 'src/components/form/tanstack/IconSelectField'
import InputField from 'src/components/form/tanstack/InputField'
import LateFeeConfigurationField from 'src/components/form/tanstack/LateFeeConfigurationField'
import LetterheadSelectField from 'src/components/form/tanstack/LetterheadSelectField'
import NumberField from 'src/components/form/tanstack/NumberField'
import PhoneInputField from 'src/components/form/tanstack/PhoneInputField'
import RadioGroupField from 'src/components/form/tanstack/RadioGroupField'
import RecordTaskOwnerSelectField from 'src/components/form/tanstack/RecordTaskOwnerSelectField'
import RecordTypeStatusSelectField from 'src/components/form/tanstack/RecordTypeStatusSelectField'
import RichTextInputField from 'src/components/form/tanstack/RichTextInput'
import SelectField from 'src/components/form/tanstack/SelectField'
import StaffUserGroupSelectField from 'src/components/form/tanstack/StaffUserGroupSelectField'
import StaffUserSelectField from 'src/components/form/tanstack/StaffUserSelectField'
import StateSelectField from 'src/components/form/tanstack/StateSelectField'
import SwitchField from 'src/components/form/tanstack/SwitchField'
import TaskFieldSelectField from 'src/components/form/tanstack/TaskFieldSelectField'
import TextAreaField from 'src/components/form/tanstack/TextAreaField'
import TimeField from 'src/components/form/tanstack/TimeField'
import TimeZoneSelectField from 'src/components/form/tanstack/TimeZoneSelectField'
import UserOnCompanyRoleSelectField from 'src/components/form/tanstack/UserOnCompanyRoleSelectField'
import UserSearchField from 'src/components/form/tanstack/UserSearchField'
import WorkflowTemplateSelectField from 'src/components/form/tanstack/WorkflowTemplateSelectField'
import ZipField from 'src/components/form/tanstack/ZipField'

export const { fieldContext, formContext, useFieldContext } = createFormHookContexts()
export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    AIChatLauncherPositionSelect: AIChatLauncherPositionSelectField,
    CompanySearch: CompanySearchField,
    CompanySelect: CompanySelectField,
    CreatableStringSelect: CreatableStringSelectField,
    Date: DateField,
    DateTemplate: DateTemplateInputField,
    DistanceUnitSelect: DistanceUnitSelectField,
    EntityLayerSelect: EntityLayerSelectField,
    EntityVersionSearch: EntityVersionSearchField,
    FeeSchedule: FeeScheduleSelectField,
    FeeTemplate: FeeTemplateSelectField,
    FileUpload: FileUploadField,
    IconSelect: IconSelectField,
    Input: InputField,
    LateFeeConfiguration: LateFeeConfigurationField,
    Letterhead: LetterheadSelectField,
    Number: NumberField,
    PhoneInput: PhoneInputField,
    RadioGroup: RadioGroupField,
    RecordTaskOwnerSelect: RecordTaskOwnerSelectField,
    RecordTypeStatusSelect: RecordTypeStatusSelectField,
    RichTextInput: RichTextInputField,
    Select: SelectField,
    StaffUserGroupSelect: StaffUserGroupSelectField,
    StaffUserSelect: StaffUserSelectField,
    StateSelect: StateSelectField,
    Switch: SwitchField,
    TaskFieldSelect: TaskFieldSelectField,
    TextArea: TextAreaField,
    Time: TimeField,
    TimeZoneSelect: TimeZoneSelectField,
    UserSearch: UserSearchField,
    UserOnCompanyRoleSelect: UserOnCompanyRoleSelectField,
    WorkflowTemplateSelect: WorkflowTemplateSelectField,
    Zip: ZipField,
  },
  formComponents: {},
})
